import React from "react";
import { reduxForm } from "redux-form";
import { ff, form } from "@mc/mc-legacy";
import { Button, Col, Row } from "reactstrap";
import * as TypDokladu from "mc/lib/api/gen/subjekty/v1/TypDokladu";
import { HorizontalLoader } from "@mc/mc-legacy";
import { i18n } from "../../i18n/i18n";
import { withLang } from "../../i18n/withLang";
import "./Form.scss";

const DokladForm = (props) => {
  const { handleSubmit, error, submitting } = props;
  return (
    <form.Form className={"form"} horiznotal onSubmit={handleSubmit}>
      <form.FormBody>
        {error && <form.ValidationErrors error={error} />}
        <Row>
          <Col xs={12} md={6} className={"mb-3"}>
            <ff.Select
              className={"py-10"}
              field={false}
              name="typDokladu"
              defaultValue={TypDokladu.RP}
              disabled={submitting}
            >
              {DokladForm.formTypDokladu.map((v) => (
                <option value={v} key={v}>
                  {i18n(props.lang, `TypDokladu_${v}`)}
                </option>
              ))}
            </ff.Select>
          </Col>
          <Col xs={12}  md={6}>
            <ff.String
              label={false}
              name={"idDoklad"}
              className={"rounded-left-0 over py-10"}
              placeholder={i18n(props.lang, "DokladForm_cisloDokladu")}
              required
              disabled={submitting}
            />
          </Col>
        </Row>
      </form.FormBody>
      <form.FormActions submitButton={false}>
        <Button disabled={submitting} className={"btn btn-primary py-15"}>
          {i18n(props.lang, "button_Pokracovat")}
        </Button>
      </form.FormActions>
    </form.Form>
  );
};

DokladForm.formTypDokladu = TypDokladu.values.filter((t) => t !== TypDokladu.OSTATNI && t !== TypDokladu.RP);

DokladForm.validate = (formData, props) => {
  const errors = {};

  if (!formData.idDoklad) {
    errors.idDoklad = i18n(props.lang, "DokladForm_idDoklad_required");
  } else if (formData.idDoklad.length > 9) {
    errors.idDoklad = i18n(props.lang, "DokladForm_idDoklad_maxLength");
  } else if (formData.idDoklad.length < 8) {
    errors.idDoklad = i18n(props.lang, "DokladForm_idDoklad_minLength");
  }

  if (!formData.typDokladu) {
    errors.typDokladu = i18n(props.lang, "DokladForm_typDokladu_required");
  }

  return errors;
};

const DokladFormForm = reduxForm({
  form: "dokladForm",
  validate: DokladForm.validate,
})(DokladForm);
export default withLang(DokladFormForm);
